import { Outlet } from 'react-router-dom';
import BlogsSidebar from './BlogsSidebar';

export default function BlogsLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <BlogsSidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
